import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { E2eRegressionTestResults } from "services/KnowfullyAdminClient";
import RunRows from "./RunRows";

type AppSectionProps = {
  title: string;
  runs: E2eRegressionTestResults["myPortal"];
  isLoading: boolean;
  sx?: object;
};

const AppSection = ({ title, runs, isLoading, sx }: AppSectionProps) => (
  <Accordion defaultExpanded sx={sx}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="h6" sx={{ mr: 1 }}>
        {title}
      </Typography>
      {!isLoading && (
        <Chip label={runs?.length ?? 0} size="small" sx={{ alignSelf: "center" }} />
      )}
    </AccordionSummary>
    <AccordionDetails sx={{ p: 0 }}>
      {isLoading ? (
        <Box px={2} pb={2}>
          {[new Array(5)].map((_, i) => (
            <Skeleton key={i} height={40} />
          ))}
        </Box>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: 40 }} />
                <TableCell>Run</TableCell>
                <TableCell>Results</TableCell>
                <TableCell align="right">Report</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {runs?.length ? (
                runs.map((run) => <RunRows key={run.runId} run={run} />)
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>No results found.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </AccordionDetails>
  </Accordion>
);

export default AppSection;
